export const elements_category_reducer = (state="all", action) => {
	switch (action.type) {
		case "SET_ELEMENTS_CATEGORY":
  			return action.payload;
		default:
	  		return state;
    }
};